import { Directive, ElementRef, Renderer } from '@angular/core';

@Directive({
  selector: '[text-color]'
})
export class TextColorDirective {

  constructor(
    private el: ElementRef,
    private renderer: Renderer
  ) {
    this.setColor();
  }

  setColor() {
    let text_color = '#000000';

    if (localStorage.getItem('base_data') && localStorage.getItem('base_data') != '') {
      let base_data = JSON.parse(localStorage.getItem('base_data'));
      if (base_data['color']) {
        text_color = base_data['color'];
      }
    }
    this.renderer.setElementStyle(this.el.nativeElement, 'color', text_color);
  }
}


// WEBPACK FOOTER //
// ./src/directives/text-color/text-color.ts